import { action } from 'satcheljs';
export var addComposeLinkViewState = action('ADD_COMPOSE_LINK_VIEW_STATE', function (linkId) { return ({
    linkId: linkId,
}); });
export var setIsContextMenuOpen = action('SET_IS_CONTEXT_MENU_OPEN', function (linkId, value) { return ({
    linkId: linkId,
    value: value,
}); });
export var resetIsContextMenuOpenForLinks = action('RESET_IS_CONTEXT_MENU_OPEN_FOR_LINKS', function () { return ({}); });
//# sourceMappingURL=internalActions.js.map